import React from 'react';
import Icon from '@mdi/react';
import { mdiArrowUp, mdiArrowDown } from '@mdi/js';

export default function TableSortDisplayArrow({ direction, size = 0.6 }) {
  if (!direction) return null;
  return (
    <span>
      {direction === 'ASC' && <Icon path={mdiArrowUp} size={size} />}
      {direction === 'DESC' && <Icon path={mdiArrowDown} size={size} />}
    </span>
  );
}
